<template>
    <div class="landing-container">
      <div class="centered-card">
        <div>
            <HeaderBar />
        </div>
        <!-- Hero Section -->
          <section class="hero">
            <div class="hero-content">
              <div class="title-container">
                <h1 class="hero-title"><span class="yellow">MAKE</span><br>
                <span class="green">Coloring-AI <br> powered</span><br>
                <span class="blue">Creative drawings</span></h1>
                <p class="subtitle">Spark Creativity with AI-Powered<br>
                  Coloring Pages, describe anything and our AI <br> 
                  turns it into magical drawings for kids to color.</p>
                <div>
                  <p class="free-msg">No signup needed — try your first 2 drawings free!</p>
                </div>
              <div class="cta-buttons">
                <button class="primary-button" v-if="!showPrompt" @click="startPrompt"><span class="button-text">Try it now for FREE</span></button>
                <button class="secondary-button" @click="goToLogin"><span class="button-text">Join or Login →</span></button>
              </div>
            </div>
            <div class="example-images">
                  <img 
                    class="ex-image" 
                    v-for="(example, index) in ex_images" 
                    :key="index"
                    :src="example" 
                    alt="no data">
            </div>
          </div>
          <div v-if="showPrompt">
            <PromptForm />
          </div>
        </section>
        <!-- Features Section -->
        <section class="demo">
          <h1 class="blue">Short Demo</h1>
          <p class="subtitle-center">See our short video of how it works and be up to speed in minutes.</p>
          <div class="demo-container">
            <div class="video">
              <iframe width="100%" height="315" 
              src="Coming soon.." 
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowfullscreen>
              </iframe>
            </div>
            <div class="trust">
              <h3 class="parents-text green">Trusted by parents everywhere</h3>
              <div class="avatars">
                <div class="avatar">
                  <img src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg">
                </div>
                <div class="avatar">
                  <img src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg">
                </div>
                <div class="avatar">
                  <img src="https://images.pexels.com/photos/634021/pexels-photo-634021.jpeg">
                </div>
                <div class="avatar">
                  <img src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg">
                </div>
                <div class="avatar">
                  <img src="https://images.pexels.com/photos/3785079/pexels-photo-3785079.jpeg">
                </div>
              </div>
              <div class="raitings">
              <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
              </svg>
              <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
              </svg>
              <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
              <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
              <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" fill="none" stroke="gold" stroke-width="1"/>
              </svg>
              <p> Loved by 100+ users!</p>
              </div>
            </div>
          </div>
        </section>
        <section class="works">
          <h1 class="blue">How It Works</h1>
          <p class="subtitle-center"> It's never been easier just follow the instructions below <br> and your drawing will be done in seconds</p>
          <div class="work-cards">
            <div class="card">
              <div class="icon">✏️</div>
              <h3 class="green">Describe Your Idea</h3>
              <p class="desc">Type anything like "Happy girl Emma is an astronaut" or "Bunny eating carrots."</p>
            </div>
            <div class="card">
              <div class="icon">🤖</div>
              <h3 class="blue">AI Instantly Draws</h3>
              <p class="desc">Child-friendly line art generated in seconds</p>
            </div>
            <div class="card">
              <div class="icon">🖍️</div>
              <h3 class="yellow">Print & Color</h3>
              <p class="desc">Download PDFs or print directly</p>
            </div>
          </div>
        </section>
        <section class="prices">
          <h1 class="pricing orange">Pricing</h1>
          <p class="subtitle-center"> Get started with the cheapest image <br> generation tool on the market <span class="offer">only 0.018$ per image!</span></p>
          <div class="price-cards">
            <div class="card-pricing">
              <h1 class="pricing-title green">Subscribe</h1>
              <div class="discount">
              <h2 class="crossed">12.99$</h2><span class="true offer">8.99$</span>
              </div>
              <ul class="pricing-list">
              <li class="list-item">500 prompts</li>
              <li class="list-item">unlimited storage</li>
              <li class="list-item">Email support</li>
              <li class="list-item">Export to PRF/Print</li>
              </ul>
            </div>
            <div class="card-pricing">
              <h1  class="pricing-title blue">Pay Once</h1>
              <div class="discount">
              <h2 class="crossed">8.99$</h2><span class="true offer">5.99$</span>
              </div>
              <ul class="pricing-list">
              <li class="list-item">Get 100 prompts</li>
              <li class="list-item">unlimited storage</li>
              <li class="list-item">Email support</li>
              <li class="list-item">Export to PRF/Print</li>
              </ul>
            </div>
          </div>
        </section>
  
        <section class="gallery">
          <h1><span class="green">Kids Love These</span></h1>
          <p class="subtitle-center"> The results will often surprise you and if they don't <br> you have enough prompts to keep trying :) !</p>
          <div class="history-container">
            <div class="card-big" v-for="(example, index) in examples" :key="index" :data-prompt="example.prompt">
                <img :src="example.image" class="prompt-image" alt="Example coloring page">
            </div>
          </div>
        </section>
        <section class="contact">
          <h1> Contact Us </h1>
          <p class="subtitle-center" style="margin-top: 45px;"> Got questions, praise, ideas, <strong>support@coloring-ai.art</strong> is where you can find us
            please don't hesitade to contact us, <br>
            also check out our socials, leave a comment, follow, thank you!</p>
            <div class="social-icons">
              <a href="https://www.facebook.com/profile.php?id=61577953619638" class="social-link facebook" target="_blank" rel="noopener noreferrer"></a>
              <a href="https://www.linkedin.com/company/coloring-ai" class="social-link linkedin" target="_blank" rel="noopener noreferrer"></a>
              <a href="https://www.instagram.com/coloringaiart/" class="social-link instagram" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </section>
      </div>
    </div>
  </template>
  

<script setup>

import { onMounted, ref } from "vue"
import { useRouter, useRoute } from "vue-router";
import HeaderBar  from '../components/HeaderBar.vue';

import PromptForm from '../components/PromptForm.vue';

import Emma from '../assets/images/Emma.jpg'
import bunny from '../assets/images/bunny.jpg'
import rex from '../assets/images/rex.jpg'
import Charlie from '../assets/images/Charlie.jpg'

import charlie_space from '../assets/images/charli_space.jpg'
import dino_party from '../assets/images/dino_party.jpg'
import ema_sings from '../assets/images/ema_sings.jpg'
import sleepy_dragon from '../assets/images/sleepy_dragon.jpg'



import { useAuthStore } from '../stores/auth';
import { useAlertStore } from "@/stores/alert";

const router = useRouter()
const authStore = useAuthStore();
const alertStore = useAlertStore();
const route = useRoute();
const isAuthModalOpen = ref(false)

const ex_images = ref ([
    charlie_space,
    dino_party,
    ema_sings,
    sleepy_dragon
  
])


const examples = ref([
  { image: Emma, prompt: "Happy girl Emma is an astronaut" },
  { image: Charlie, prompt: "Charlie plays football" },
  { image: dino_party, prompt: "T-rex having a birthday party with his friends"},
  { image: sleepy_dragon, prompt: "Big dragon getting ready to go to sleep"},
  { image: bunny, prompt: "Cool bunny eats carrot" },
  { image: rex, prompt: "T-rex wearing glasses" }
]);


onMounted(async () => {
  const rawPath = route.path;
  const queryString = rawPath.split(/#/)[1]
  const params = new URLSearchParams(queryString)

  if (params.type === 'signup') {
    router.push("/home")

  } else if ("error" in params) {
    console.log("Error confirming email :(")
    router.push("/home")
    }
    else if (authStore?.session) {
     router.push('/home')
  }
})


const showPrompt = ref(false)

function startPrompt() {
  showPrompt.value = true;
  alertStore.clear;
}

function goToLogin() {
  router.push('/home');
}


const showAuthModal = () => {
  isAuthModalOpen.value = true;
};

const closeAuthModal = () => {
  isAuthModalOpen.value = false;
};

const handleLoginSuccess = () => {
  closeAuthModal();
};

</script>
  
<style scoped>

  .landing-container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: 50%;
    padding: 20px;
    box-sizing: border-box;
  }

  .star {
  fill: gold;
  border-color: gold;   /* this changes the star color */
}
  
  .centered-card {
    background: white;
    max-width: 900px;
    border-radius: 15px;
    padding: 0.2rem 2.5rem 2.5rem 2.5rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    margin: 20px 0;
  }
  
  .hero, .works, .prices, .demo{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    padding-bottom: 2rem;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 2rem;
  }
  
  .button-text {
    font-size: 20px;
    font-weight: 800;
    color:white;
  }



  .demo-container {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    gap: 2px;
    align-items: center;
    padding: 10px;
  }

  .trust {
            text-align: center;
            max-width: 600px;
            margin: 0 auto;
        }

.avatars{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.avatars{
  display: flex;
  overflow: hidden;
  gap: -20px;
}

.avatars {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: -20px; /* This creates the overlap */
  transition: transform 0.3s ease, z-index 0.3s ease;
  position: relative;
  z-index: 1;
}

.avatar:first-child {
    margin-left: 0; /* First avatar doesn't need left margin */
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.crossed {
  text-decoration: line-through;
  text-align: center;
}

.true{
  text-align: left;
  font-size: 3.2rem;
  font-weight: 800;
}

  .demo h1 {
  /* text-align: center; */
  margin-bottom: 20px;
}

.video iframe {
  width: 100%;
  margin-top: -30px;
  border-radius: 5px;
}

.parents-text {
  font-weight: 600;
}

.gallery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  padding: 0.5rem 2rem;
  background: white;
  border-bottom: 3px solid transparent;
  background-clip: padding-box;
  border-image: linear-gradient(90deg, #22c55e, #3b82f6, #facc15) 1;
  margin-bottom: 2.5rem;
  position: relative;
  overflow: hidden;
}

.gallery > * {
  position: relative;
  z-index: 2;
}

.subtitle-center {
  color: black;
  font-size: 1.2rem;
  line-height: 1.2;
  font-weight: 400;
  max-width: 600px;
  margin: 0 auto 1rem auto;
}

.pricing-list li {
    padding: 0.7rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 350;
    color: black;
    line-height: 1.2;
}

  .hero-content {
    display: flex;
    align-items: center;
    gap: 3rem;
    flex-wrap: wrap;
  }



  /* EXAMPLE IMAGES */

  .example-images {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  max-width: 350px;
  margin: 0 auto;
  width: 50%;
}

.ex-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 
    0 8px 20px rgba(0, 0, 0, 0.12),
    0 3px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

/* Individual tilts for each image */
.ex-image:nth-child(1) {
  transform: rotate(-3deg);
}

.ex-image:nth-child(2) {
  transform: rotate(2deg);
}

.ex-image:nth-child(3) {
  transform: rotate(1.5deg);
}

.ex-image:nth-child(4) {
  transform: rotate(-2.5deg);
}

/* Hover effects */
.ex-image:hover {
  transform: rotate(0deg) scale(1.05) translateY(-10px);
  box-shadow: 
    0 25px 50px rgba(0, 0, 0, 0.25),
    0 15px 35px rgba(0, 0, 0, 0.15),
    0 0 0 6px rgba(255, 255, 255, 0.9);
  z-index: 10;
  position: relative;
}

.card:hover {
  transform: rotate(0deg) scale(1.05) translateY(-10px);
  box-shadow: 
    0 8px 20px rgba(0, 0, 0, 0.12),
    0 3px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 10;
  position: relative;
}

.work-cards {
  flex: 1;
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 80px;
  }

.price-cards {
  flex: 1;
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 80px;
}

.card {
      flex: 1;
      min-width: 100px;
      max-width: 200px;
      padding: 1rem 1rem;
      border: 2px solid white;
      box-shadow: 
      0 15px 30px rgba(0, 0, 0, 0.15),
        0 0 0 6px rgba(255, 255, 255, 0.9);
      border-radius: 10px;
      text-align: center;
      position: relative;
      overflow: hidden;
  }

.card-pricing {
      flex: 1;
      min-width: 100px;
      max-width: 350px;
      padding: 1rem 1rem;
      border: 2px solid white;
      box-shadow: 
      0 15px 30px rgba(0, 0, 0, 0.15),
        0 0 0 6px rgba(255, 255, 255, 0.9);
      border-radius: 10px;
      text-align: center;
      position: relative;
      overflow: hidden;

}


.discount {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 0px;
}



  /* Card Styles with Rotating Colors */
.card-big {
  flex: 1;
  min-width: 100px;
  max-width: 450px;
  padding: 1.5rem;
  border-radius: 15px 15px 0 0;
  box-shadow: 
      0 15px 15px rgba(0, 0, 0, 0.15),
        0 0 0 6px rgba(255, 255, 255, 0.9);
  text-align: center;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

  /* .card-big:hover {
  transform: rotate(0deg) scale(1.05) translateY(-10px);
  box-shadow: 
    0 8px 20px rgba(0, 0, 0, 0.12),
    0 3px 10px rgba(0, 0, 0, 0.08);
  transition: all 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 10;
  position: relative;
} */

/* Alternative hover effects for variety */
.ex-image:nth-child(1):hover {
  transform: rotate(-1deg) scale(1.08) translateY(-12px);
}

.ex-image:nth-child(2):hover {
  transform: rotate(1deg) scale(1.06) translateY(-8px);
}

.ex-image:nth-child(3):hover {
  transform: rotate(-0.5deg) scale(1.07) translateY(-15px);
}

.ex-image:nth-child(4):hover {
  transform: rotate(0.5deg) scale(1.05) translateY(-10px);
}

/* Add a subtle background pattern */
.example.images::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 20%, rgba(120, 119, 198, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(255, 119, 198, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: -1;
}

.example.images {
  position: relative;
}



 /* FREE MSG */

 .free-msg {
  background: linear-gradient(135deg, 
    rgba(255, 252, 240, 0.8) 0%, 
    rgba(254, 249, 195, 0.6) 50%, 
    rgba(253, 244, 216, 0.4) 100%);
  backdrop-filter: blur(10px);
  color: #78716c;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  margin: 1.5rem auto;
  display: inline-block;
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.05),
    0 1px 3px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: default;
}

/* Add a subtle shine effect */
.free-msg::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent, 
    rgba(255, 255, 255, 0.2), 
    transparent);
  transition: left 0.6s ease;
}

.free-msg:hover::before {
  left: 100%;
}


/* Container styling */
.free-msg-container {
  text-align: center;
  margin: 1rem 0;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1.1;
  color: black;
  margin-bottom: 24px;
  text-align: left;
}

.subtitle {
  font-size: 1.1rem;
  color: #323232;
  margin-bottom: 1rem;
  text-align: left;
}

.subtitle-center {
  font-size: 1.1rem;
  color: #323232;
  margin-bottom: 2rem;
  text-align: center;
}


.cta-buttons {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2rem;
}

button {
  padding: 0.8rem 1.5rem;
  max-width: 420px;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  border: 3px solid;
}

.red { 
  color: #ff6b6b;
  font-weight: 700;
}

.blue {
  color:#578FCA;
  font-weight: 700;
}

.green {
  color:#8EB486;
  font-weight: 700;
}

.yellow {
  color: #FADA7A;
  font-weight: 700;
}

.orange {
  color: #FFAF47;
  font-weight: 700; 
}

.primary-button {
  background-color: #8EB486;
  border-color: #8EB486;
}

.secondary-button {
  background-color: #578FCA;
  border-color: #578FCA;
}

button:hover {
border-color: #42a8b4;
background-color: #42a8b4;
}

.hero-preview {
  margin: 0 auto;
  max-width: 400px;
  border: 3px solid #ccc;
  border-radius: 10px;
  padding: 1rem;
}

/* Features */
.feature-cards {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.feature-card {
  flex: 1;
  min-width: 200px;
  max-width: 250px;
  max-height: 250px;
  padding: 1.5rem 1rem;
  border: 2px solid #ccc;
  border-radius: 10px;
  text-align: center;
}

.feature-card .icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

/* Pricing */

/* .pricing-cards {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
      } */

.prices h1,
.works h1,
.gallery h1,
.contact h1,
.demo h1 {
    text-align: center;
    font-size: 2.2rem;
    line-height: 1.1;
    font-weight: 800;
    margin-bottom: 5px;
}

.offer {
  display: inline-block;
  margin-top: 1px;
  padding: 0 15px 0 5px;
  font-weight: 600;
  /* background-color: #FFAF47; */
  rotate: -2deg;
  background: linear-gradient(
    to bottom,
    white 50%,   /* left half */
    #FFAF47 50%     /* right half */
  );
}

.pricing h3 {
    text-align: center;
    font-size: 1rem;
    color: rgb(10, 10, 10);
    margin-bottom: 1rem;
    font-weight: 600;
}

.pricing-card .icon {
    font-size: 1rem;
    margin-bottom: 1rem;
}

.pricing-card {
    flex: 1;
    min-width: 100px;
    max-width: 200px;
    padding: 0.5rem 0.5rem;
    border: 2px solid #ccc;
    border-radius: 5px;
    text-align: center;
    position: relative;
    overflow: hidden;
}


/* Disabled state for cards 2 and 3 */
.card.disabled {
    opacity: 0.7;
}

.card.disabled h3 {
    color: #999;
}

.card.disabled .pricing-list li {
    color: #999;
}

.card.disabled .pricing-list li::before {
    color: #ccc;
}


.card.disabled::before {
    content: "Not Yet Available";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(45deg, #ff6b6b, #ee5a24);
    color: white;
    padding: 0.3rem;
    font-weight: bold;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    z-index: 1;
}

.card-big::before {
  content: attr(data-prompt);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, #578FCA);
  color: white;
  padding: 0.3rem;
  font-weight: bold;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 2;
}

.card.disabled {
    padding-top: 2rem;
}

.pricing-list {
    list-style: none;
    padding: 0 0 0 20px;
    text-align: left;
}

.pricing-list li {
    padding: 0.7rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 350;
    color: black;
    line-height: 1.2;
}

.pricing-list li:last-child {
    border-bottom: none;
}

.pricing-list li::before {
    content: "✔️";
    color: #4CAF50;
    font-weight: bold;
    font-size: 0.8rem;
    margin-right: 0.5rem;
    flex-shrink: 0;
}

  .desc {
    font-size: 0.9rem;
    margin-right: 0.5rem;
    flex-shrink: 0
}


  /* History Container */
.history-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
}
    
.prompt-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
  margin-bottom: 0.5rem;
}

.pro {
  margin: 2px;
}

/* SOCIALS */

.social-icons {
display: flex;
justify-content: center;
align-items: center;
gap: 1.5rem;
}

.social-link {
  width: 65px;
  height: 65px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  transition: filter 0.3s ease, transform 0.3s ease;
}

.social-link:hover {
  filter: grayscale(0%);
  transform: scale(1.05);
}

/* Icons using Font Awesome or SVG as background */
.social-link.facebook {
  background-image: url('https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/facebook.svg');
  background-color: #42a8b460;
}

.social-link.linkedin {
  background-image: url('https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/linkedin.svg');
  background-color: #6ff18960;
}

.social-link.instagram {
  background-image: url('https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg');
  background-color: #ecec0f60;
}

@media (max-width: 1024px) {

.title-container {
  display: block;
  max-width: 100%;
}

/* Hidden because I don't know how to fix them when going beloow 1024px screen if you do, remove this and fix it */
.example-images{
  display: none;
}

.hero-content {
  display: block;
  text-align: center;
}

.subtitle {
  text-align: center;
}

.cta-buttons {
  display: block;
}

.primary-button{
  margin: 2.5px;
}

.secondary-button{
  margin: 2.5px;
}

.hero-title {
  text-align: center;
}

/* .example-images {
  display: block;
  gap: 1rem;
  padding: 1.5rem 0.5rem;
  max-width: 150px;
  width: 80%;
} */

.ex-image {
  height: 150px;
  border-radius: 10px;
}

.ex-image:hover {
  transform: rotate(0deg) scale(1.03) translateY(-5px);
}
}

  /* Responsive */
  @media (max-width: 768px) {
    .centered-card {
      padding: 1.5rem;
    }
    
    .history-container {
      grid-template-columns: 1fr;
    }

    .demo-container {
      grid-template-columns: 1fr;
    }
    
    .feature-cards {
      flex-direction: column;
      align-items: center;
    }
    
    .feature-card {
      max-width: 100%;
    }

    .price-cards {
      display: block;
      justify-items: center;
      padding-bottom: 0px;
    }

    .card-pricing {
      width: 100%;
      margin-bottom: 40px;
    }

  .free-msg {
    font-size: 0.85rem;
    padding: 0.6rem 1.2rem;
    margin: 1rem auto;
  }

    .example.images {
    gap: 1rem;
    padding: 1.5rem 0.5rem;
    max-width: 300px;
    width: 80%;
  }

  .ex-image {
    height: 150px;
    border-radius: 10px;
  }

  .ex-image:hover {
    transform: rotate(0deg) scale(1.03) translateY(-5px);
  }
}

@media (max-width: 480px) {
  .free-msg {
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
    margin: 0.8rem auto;
    max-width: 90%;
  }
  .example.images {
  grid-template-columns: 1fr;
  max-width: 200px;
  width: 90%;
}

.ex-image:nth-child(1),
.ex-image:nth-child(2),
.ex-image:nth-child(3),
.ex-image:nth-child(4) {
  transform: rotate(0deg);
}

.ex-image:hover {
  transform: scale(1.02) translateY(-3px);
}
 
}

/* Responsive design
@media (max-width: 768px) {

}

/* @media (max-width: 480px) {
.example.images {
  grid-template-columns: 1fr;
  max-width: 200px;
  width: 90%;
}

.ex-image:nth-child(1),
.ex-image:nth-child(2),
.ex-image:nth-child(3),
.ex-image:nth-child(4) {
  transform: rotate(0deg);
}

.ex-image:hover {
  transform: scale(1.02) translateY(-3px);
}
} */

</style>